var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleAnalyticsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 192 192"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9AB00",
  d: "M130 29v132c0 14.77 10.19 23 21 23 10 0 21-7 21-23V30c0-13.54-10-22-21-22s-21 9.33-21 21"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E37400",
  d: "M75 96v65c0 14.77 10.19 23 21 23 10 0 21-7 21-23V97c0-13.54-10-22-21-22s-21 9.33-21 21"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 163,
  r: 21,
  fill: "#E37400"
})));
export default SvgGoogleAnalyticsLogo;